import { fetchAuthToken } from "app/Auth";
import { client } from "common/apiClient";

export const markParentsNotification = async ({ uid }: { uid: string }) => {
  const token = await fetchAuthToken();
  return client({ token: token }).put(
    `/v1/user/config/${uid}/mark/notification`
  );
};
